import { ApiContextType } from '../api-context';
import {
    DrillFileDetails,
    FetchDrillsRequest,
    FetchDrillsResponse,
    Package,
    UpdateDrillRequest
} from '../typings';

export const fetchDrills = (api: ApiContextType, request: FetchDrillsRequest): Promise<FetchDrillsResponse> => {
    return api.post(`/drills`, request)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const fetchPackagesWithoutDrill = (api: ApiContextType, id: number): Promise<Package[]> => {
    return api.get(`/drill/${id}/not-in-packages`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const fetchPackagesWithDrill = (api: ApiContextType, id: number): Promise<Package[]> => {
    return api.get(`/drill/${id}/in-packages`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const addDrill = (api: ApiContextType, id: number, request: number[]): Promise<void> => {
    return api.put(`/drill/${id}/add`, request)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const removeDrill = (api: ApiContextType, id: number, request: number[]): Promise<void> => {
    return api.put(`/drill/${id}/remove`, request)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const deleteDrill = (api: ApiContextType, id: number): Promise<void> => {
    return api.del(`/drill/${id}`)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const fetchDrill = (api: ApiContextType, id: number): Promise<DrillFileDetails> => {
    return api.get(`/drill/${id}`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const updateDrill = (api: ApiContextType, id: number, request: UpdateDrillRequest): Promise<void> => {
    return api.post(`/drill/${id}`, request)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

